import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  CLEAR_ITINERARY_CLOSURE_REASONS,
  CLEAR_ITINERARY_CLOSURE_TOTAL_SALE_PRICE,
  FLAG_GETTING_ITINERARY_CLOSURE_REASONS,
  FLAG_ITINERARY_CLOSURE_REASON_ACTIVITY,
  GET_ITINERARY_CLOSURE_REASONS,
  GET_TOTAL_SALE_PRICE_FOR_ITINERARY_CLOSURE,
} from '../../../actions/types';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
    activity: Immutable.List(),
    totalSalePrice: 0,
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_GETTING_ITINERARY_CLOSURE_REASONS:
      return state.setIn(['all', 'loading'], action.payload);
    case GET_ITINERARY_CLOSURE_REASONS:
      return state.setIn(['all', 'content'], Immutable.Map(action.payload));
    case CLEAR_ITINERARY_CLOSURE_REASONS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_ITINERARY_CLOSURE_REASON_ACTIVITY:
      if (action.payload) {
        return state.setIn(
          ['all', 'activity'],
          state.getIn(['all', 'activity']).push(action.payload),
        );
      }

      return state.setIn(
        ['all', 'activity'],
        state.getIn(['all', 'activity']).pop(),
      );
    case GET_TOTAL_SALE_PRICE_FOR_ITINERARY_CLOSURE:
      return state.setIn(['all', 'totalSalePrice'], action.payload);

    case CLEAR_ITINERARY_CLOSURE_TOTAL_SALE_PRICE:
      return state.setIn(['all', 'totalSalePrice'], 0);
    default:
      return state;
  }
};
